import { Container } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import Checkbox from '../../../Inputs/Checkbox/Checkbox'
import Typography from '../../../Typography/Typography'
import './PointPayment.scss'

const PointPayment = ({ points, onChange, checked, disabled }) => {
    const intl = useIntl()

    return (
        <Container fluid className={'ticket-point-payment d-flex justify-content-center align-items-center gap-3'}>
            <Checkbox
                color={'purple'}
                key={'ticket-point-payment'}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
            <Typography variant={'desc'} className={disabled ? 'opacity-50' : ''}>
                {intl.formatMessage({ id: 'ticket.pointPayment' }, { points })}
            </Typography>
        </Container>
    )
}

export default PointPayment
